<template>
  <li class="nav-item notificaciones">
    <a :class="['nav-link flex-lg-column flex-xl-row', { active: props.esActivo }]" aria-current="page">
      <span class="position-relative">
        <i class="fa-regular fa-bell text-success fa-xl"></i>
        <span class="badge bg-success translate-middle-x translate-middle-y text-black">{{ numNotificaciones }}</span>
      </span>
    </a>
  </li>
</template>

<script setup lang="ts">
const props = defineProps({
  ruta: String,
  claseCss: String,
  esActivo: Boolean,
  texto: String,
  numNotificaciones: Number,
});
</script>

<style lang="scss" scoped>

.notificaciones {
  cursor: pointer;
  position: relative;

  a > span:first-of-type {
    min-width: 50px;
  }
}

.nav-item a:not(.active) {
  color: var(--border-default-default);
}

.navbar-nav .nav-link.active {
  border-bottom: 5px solid var(--border-success-default);
  padding-bottom: 5px;
}

@media (max-width: 991px) {
  .navbar-collapse.collapse .nav-link {
    padding: 15px var(--spacing-0);
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav .nav-link,
  .navbar-text {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    gap: 5px;
    align-items: center;
    min-height: 70px;
  }
}
</style>
